import { render, staticRenderFns } from "./coperarkmandigerrezaktarim.vue?vue&type=template&id=133fa815&"
import script from "./coperarkmandigerrezaktarim.vue?vue&type=script&lang=js&"
export * from "./coperarkmandigerrezaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports